import { useEffect } from "react";
import { proxy, useSnapshot } from "valtio";
import { AlternativeProductGroup } from "../../../hooks/useAlternativeProducts";
import { MenuIds, useMenus } from "../../../hooks/useMenus";

interface IAlternativeProductsPanelState {
	selectedAlternativeProductGroup: AlternativeProductGroup | undefined;
}

const state = proxy<IAlternativeProductsPanelState>({
	selectedAlternativeProductGroup: undefined,
});

function setSelectedAlternativeProductGroup(group: AlternativeProductGroup | undefined) {
	state.selectedAlternativeProductGroup = group;
}

export const useSelectedAlternativeProductGroupState = () => {
	const { menuId } = useMenus();

	// Clear the selected alternative product if no alternative products shown in bottom menu
	useEffect(() => {
		if (menuId !== MenuIds.AlternativeProducts) {
			setSelectedAlternativeProductGroup(undefined);
		}
	}, [menuId]);

	return [
		useSnapshot(state).selectedAlternativeProductGroup,
		setSelectedAlternativeProductGroup,
	] as const;
};
